import { EyeNoneIcon, EyeOpenIcon } from '@radix-ui/react-icons'
import { TooltipWrapper } from 'components/TooltipWrapper'
import { useKestrel } from 'features/kestrelViewer'
import { KestrelCommands } from 'features/kestrelViewer/types/KestrelCommands'
import React, { FC } from 'react'
import styled from 'styled-components'
import { KVPrimitive } from 'types'

const StyledEyeClosedIcon = styled(EyeNoneIcon)`
  color: lightgray;
  &:hover {
    color: white;
  }
`

const StyledEyeOpenIcon = styled(EyeOpenIcon)`
  color: lightgray;
  &:hover {
    color: white;
  }
`

export const TogglePrimitiveVisibilityButton: FC<{
  primitive: KVPrimitive
}> = ({ primitive }) => {
  const { sendKVCommand, updatePrimitive } = useKestrel()

  const toggleVisibility = (e: React.MouseEvent) => {
    e.stopPropagation()
    const isVisible = primitive.visible

    if (!sendKVCommand) return

    // Send command to Unreal
    sendKVCommand({
      command: KestrelCommands.SET_PRIMITIVE_VISIBLE,
      primitiveId: primitive.id,
      visible: !isVisible,
    })

    // Update local state and selected markup using updatePrimitive
    if (updatePrimitive) {
      updatePrimitive(
        primitive,
        'visible',
        (p: KVPrimitive) => {
          p.visible = !isVisible
          return p
        },
        !isVisible
      )
    }
  }

  return (
    <TooltipWrapper
      label={primitive.visible ? 'Hide primitive' : 'Show primitive'}
      side='top'>
      <div style={{ cursor: 'pointer' }} onClick={(e) => toggleVisibility(e)}>
        {primitive.visible ? (
          <StyledEyeOpenIcon width={22} height={22} />
        ) : (
          <StyledEyeClosedIcon width={22} height={22} />
        )}
      </div>
    </TooltipWrapper>
  )
}
